import { TemplateVisibility } from '@d-id/types';
import * as yup from 'yup';

const hexColorPattern = /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/;

export const validationSchema = yup.object({
    templateName: yup.string().required('Template name is required'),
    tags: yup.array().of(yup.string().required('Each tag must be a string')).optional(),
    fonts: yup
        .object({
            primary: yup.string().required('Primary font is required'),
            secondary: yup.string().optional(),
            tertiary: yup.string().optional(),
        })
        .required(),
    colors: yup
        .object({
            primary: yup.string().required('Primary color is required').matches(hexColorPattern, 'Primary color must be a valid hex color'),
            secondary: yup.string().optional().matches(hexColorPattern, 'Secondary color must be a valid hex color'),
            tertiary: yup.string().optional().matches(hexColorPattern, 'Tertiary color must be a valid hex color'),
        })
        .required(),
    visibility: yup
        .mixed<TemplateVisibility>()
        .oneOf(Object.values(TemplateVisibility), 'Visibility must be SHOW or HIDE')
        .required('Visibility is required'),
    rank: yup.number().typeError('Rank must be a number').required('Rank is required'),
});
